import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import SaveCardForm from './SaveCardForm';

import CancelIcon from "../../../assets/cancel_icon.svg";


//const stripePromise = loadStripe("pk_test_51HjSRkBT9Re7oqqozwSAxBffWK1LTkWzEMz4mm8mi2djhjrXQw1JLYyziXHkvOdYy7l7WPvSg1RNrmf0092MbPBi00rMhSkk2O");


export default function AddWeb2CardComponent(props){

    let modalWidth = "446px";
    let modalHeight = "440px";

    
    return (
        <Modal
	    isOpen={props.isOpen}
	    style={{
		content: {
		    background: "#0F0F0F",
		    width: modalWidth,
		    height: modalHeight,
		    marginLeft: "auto",
		    marginRight: "auto",
		    marginTop: "auto",
		    marginBottom: "auto",
		    border:"none",
		}
	    }}
	>
            <div style={{
	        display: 'flex',
	        flexDirection: 'column',
	        position: 'relative',
	        alignItems: 'center',
                height:'100%'
            }}>

                    <img onClick={()=>{props.handleModalCloseEvent()}}
		         src={CancelIcon}
		         style={{
			     position: "absolute", opacity: 0.4,
			     height: 14, width:14,
			     right:10, cursor:"pointer",
			     zIndex:10,
		         }}
		    />
                    <div style={{marginTop: 30, height:'100%'}}>
		        <SaveCardForm />
                    </div>
            </div>
        </Modal>
    );
}
